import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule, MatDialogModule, MatIconModule, MatInputModule, MatRadioModule, MatTabsModule, MatCheckboxModule, MatSelectModule } from '@angular/material';
import { ExportAuditDialogComponent } from './export-audit-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatRadioModule,
    MatTabsModule,
    MatCheckboxModule,
    MatSelectModule
  ],
  declarations: [ExportAuditDialogComponent],
  entryComponents: [ExportAuditDialogComponent],
  exports: [ExportAuditDialogComponent]
})
export class ExportAuditDialogModule {
}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/dialogs/export-audit-dialog/export-audit-dialog.module.ts